/**
 * The Budget Workbench's retire-seat, with the position-request gate.
 *
 * Since 12 Oct 2026 the server refuses to retire a seat a position request is
 * still waiting to fill (409, error 'requested_seat'). The Workbench is the one
 * place it can be retired anyway: only on a deliberate yes, and the server then
 * records the released request on the ledger row.
 */

export type RetireSeatOutcome =
  | { retired: true; releasedRequest?: string }
  | { retired: false; keptFor: string };

/** `retire(releaseRequest)` posts retire-seat; `confirmRelease` asks the operator. */
export async function retireSeatWithRequestGate(
  retire: (releaseRequest: boolean) => Promise<{ released_request?: string }>,
  confirmRelease: (detail: string, requestNumber: string) => Promise<boolean>,
): Promise<RetireSeatOutcome> {
  try {
    await retire(false);
    return { retired: true };
  } catch (e: any) {
    const d = e?.response?.data?.detail;
    if (e?.response?.status !== 409 || d?.error !== 'requested_seat') throw e;
    const requestNumber = String(d.request_number || '');
    if (!(await confirmRelease(String(d.detail || ''), requestNumber))) {
      return { retired: false, keptFor: requestNumber };
    }
    const r = await retire(true);
    return { retired: true, releasedRequest: r?.released_request || requestNumber };
  }
}
